import { TextField } from '@material-ui/core'
import { AutocompleteRenderInputParams } from '@material-ui/lab'
import { graphql } from 'babel-plugin-relay/macro'
import { Field, useField } from 'formik'
import { Autocomplete } from 'formik-material-ui-lab'
import React from 'react'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { ExternalShippingLineFieldQuery } from '../../__generated__/ExternalShippingLineFieldQuery.graphql'
import { FieldT, FieldVariantEnum } from './types'

interface Props {
  field: FieldT
  variant?: FieldVariantEnum
}

const ExternalShippingLineField: React.FC<Props> & { Skeleton: React.FC } = ({ field }) => {
  const data = useLazyLoadQuery<ExternalShippingLineFieldQuery>(query, { type: 'shipping_lines' })
  const options = data.shippingLineList.items?.edges?.map((edge) => edge?.node)
  const [, meta, helpers] = useField(field.name)
  const selectedOption = meta.value ? options?.find((opt: any) => opt?.slug === meta.value) : null

  return (
    <Field
      name={field.name}
      component={Autocomplete}
      options={options}
      getOptionLabel={(option: any) => option?.title || ''}
      getOptionSelected={(option: any, value: any) => option?.slug === value?.slug}
      value={selectedOption || null}
      onChange={(_: any, value: any) => (value ? helpers.setValue(value.slug) : helpers.setValue(null))}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          error={meta.touched && !!meta.error}
          helperText={meta.touched ? meta.error : null}
          label={field.title}
          variant='outlined'
        />
      )}
      renderOption={(option: any) => <>{option.title}</>}
    />
  )
}

ExternalShippingLineField.Skeleton = () => <>Loading...</>

const query = graphql`
  query ExternalShippingLineFieldQuery {
    shippingLineList {
      items {
        edges {
          node {
            slug
            title
          }
        }
      }
    }
  }
`

export default ExternalShippingLineField
